import { __assign, __rest } from "tslib";
import React from "react";
import { EmptyTip } from "./EmptyTip";
import { LoadingTip } from "./LoadingTip";
import { ErrorTip } from "./ErrorTip";
import { FoundTip } from "./FoundTip";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var StatusTip = forwardRefWithStatics(function StatusTip(_a, ref) {
    var status = _a.status, emptyText = _a.emptyText, loadingText = _a.loadingText, errorText = _a.errorText, foundText = _a.foundText, clearResultText = _a.clearResultText, retryText = _a.retryText, onClear = _a.onClear, onRetry = _a.onRetry, hideIcon = _a.hideIcon, styledProps = __rest(_a, ["status", "emptyText", "loadingText", "errorText", "foundText", "clearResultText", "retryText", "onClear", "onRetry", "hideIcon"]);
    switch (status) {
        case "loading":
            return (React.createElement(LoadingTip, __assign({ ref: ref }, styledProps, { loadingText: loadingText, hideIcon: hideIcon })));
        case "empty":
            return React.createElement(EmptyTip, __assign({ ref: ref }, styledProps, { emptyText: emptyText }));
        case "found":
            return (React.createElement(FoundTip, __assign({ ref: ref }, styledProps, { foundText: foundText, onClear: onClear, clearResultText: clearResultText })));
        case "error":
            return (React.createElement(ErrorTip, __assign({ ref: ref }, styledProps, { errorText: errorText, retryText: retryText, onRetry: onRetry, hideIcon: hideIcon })));
    }
    return null;
}, {
    LoadingTip: LoadingTip,
    EmptyTip: EmptyTip,
    FoundTip: FoundTip,
    ErrorTip: ErrorTip,
});
StatusTip.displayName = "StatusTip";
//# sourceMappingURL=StatusTip.js.map